import { downloadFile } from '@shared/helpers/download-file.helper';
import { UntypedFormGroup } from '@angular/forms';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
  input
} from '@angular/core';
import { Attachment } from '@shared/interfaces/attachment.interface';
import { privateFile } from '@shared/helpers/private-file.helper';
import { AttachmentsManageService } from '../../services/attachments-manage.service';
import { Subscription } from 'rxjs';
import { ButtonTypes, ButtonSize } from '@shared/modules/ui/components/button/button.component';

@Component({
  selector: 'attachment-inline-v2',
  styleUrls: ['./attachment-inline-v2.component.scss'],
  templateUrl: './attachment-inline-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttachmentInlineV2Component implements OnInit, OnDestroy {
  ButtonTypes = ButtonTypes;
  ButtonSize = ButtonSize;

  _attachment: Attachment = null;
  isImage: boolean = false;
  isPdf: boolean = false;

  sub: Subscription;

  uploadProgress = input<number>();

  @Input() index: number;
  @Input() form: UntypedFormGroup;
  @Input() privateFile: boolean = true;
  @Input() disabled: boolean = false;
  @Input() groupName: string = 'attachments';

  @Input()
  set attachment(_attachment: Attachment) {
    this._attachment = _attachment;
    this.isImage = this._attachment?.type?.toString().indexOf('image') > -1;
    this.isPdf = this._attachment?.type?.toString().indexOf('pdf') > -1;
    this.changes.detectChanges();
  }

  get attachment() {
    return this._attachment;
  }

  downloading: boolean = false;

  get fancyboxUrl() {
    return `gallery-attachment-inline-${this.index}`;
  }

  get formGroup() {
    return this.form?.get(this.groupName);
  }

  get control() {
    return this.formGroup?.get(this.attachment?.id?.toString());
  }

  constructor(
    private service: AttachmentsManageService,
    private changes: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscribeControlChange();
  }

  subscribeControlChange() {
    this.sub = this.form
      .get(this.groupName)
      .get(this.attachment?.id?.toString())
      .valueChanges.subscribe(() => this.changes.detectChanges());
  }

  downloadAttachment() {
    if (this.downloading) return;
    this.downloading = true;
    this.changes.detectChanges();
    this.service
      .getFileBlob(privateFile(this.attachment.file), false)
      .subscribe({
        next: (res) => downloadFile(res, this.attachment.name)
      })
      .add(() => {
        this.downloading = false;
        this.changes.detectChanges();
      });
  }

  openPreview(event: MouseEvent): void {
    if (!this.attachment?.isUploaded || !this.fancyboxUrl || !this.isPreviewableInFancybox) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  get isPreviewableInFancybox(): boolean {
    return this.isImage || this.isPdf;
  }

  ngOnDestroy() {
    this.sub ? this.sub.unsubscribe() : null;
  }
}
